import React from "react";
import PosJournalDetail from "../component/PosJournalDetail";

const PosJournalDetailContainer = () => (<PosJournalDetail />)

export default PosJournalDetailContainer;
